import React, { useState, useEffect } from "react";
import { Box, Typography, Divider, List, ListItem, ListItemButton, ListItemText, Button, Drawer } from "@mui/material";
import AddEditCategory from "./AddEditCat";
import AddEditProduct from "./AddEditProduct";
import AddEditImages from "./AddEditImages";
import ManageUsers from "./ManageUsers";

import { onAuthStateChangedListener, logout } from "./firebaseServices"; // Importing from firebaseServices.js

function AdminPage() {
  const [selectedSection, setSelectedSection] = useState("Categories");
  const [userEmail, setUserEmail] = useState(null); // State to store user email

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = onAuthStateChangedListener((user) => {
      if (user) {
        setUserEmail(user.email); // Set the user's email if logged in
      } else {
        setUserEmail(null); // Set to null if no user is logged in
      }
    });

    // Cleanup listener on component unmount
    return () => unsubscribe();
  }, []);

  const handleSectionClick = (section) => {
    setSelectedSection(section);
  };

  const handleLogout = async () => {
    try {
      await logout(); // Call the logout function from firebaseServices.js
      console.log("Logged out successfully");
      setUserEmail(null); // Reset email after logout
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Drawer */}
      <Drawer
        variant="permanent"
        anchor="left"
        sx={{
          width: 270,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 270,
            boxSizing: "border-box",
          },
        }}
      >
        <Box sx={{ padding: 2 }}>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/officialimages-523a5.firebasestorage.app/o/img%2FDL_Logo_plain_72dpi.png?alt=media&token=e9013a5b-ac45-43c6-b6ca-98938b1b9480"
            alt="DL Logo"
            width="200"
          />
          <Typography variant="h6" sx={{ marginBottom: 3 }}>
            Administration
          </Typography>

          {userEmail ? (
            <>
              <Typography variant="body1">Logged in as:</Typography>
              <Typography fontWeight="bold" sx={{ mb: 2 }}>
                {userEmail}
              </Typography>
              <Button variant="outlined" color="error" fullWidth sx={{ marginTop: 1 }} onClick={handleLogout}>
                Log Out
              </Button>
            </>
          ) : (
            <Typography variant="body1" fontWeight="bold">
              Not logged in
            </Typography>
          )}
        </Box>

        <Divider />

        {/* Manage Data Heading */}
        <Box sx={{ padding: 2 }}>
          <Typography variant="h6" fontWeight="bold">
            Manage Data
          </Typography>
        </Box>

        <Divider />

        <List>
          {["Users", "Categories", "Products", "Images"].map((text) => (
            <ListItem key={text} disablePadding>
              <ListItemButton selected={selectedSection === text} onClick={() => handleSectionClick(text)}>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundColor: "#f5f5f5",
          padding: 3,
        }}
      >
        <Typography variant="h4" gutterBottom>
          {selectedSection}
        </Typography>
        <Box>
          {/* Render the content for the selected section */}
          {selectedSection === "Categories" && <AddEditCategory />}
          {selectedSection === "Products" && <AddEditProduct />}
          {selectedSection === "Users" && <ManageUsers />}
          {selectedSection === "Images" && <AddEditImages />}
        </Box>
      </Box>
    </Box>
  );
}

export default AdminPage;
